import Logo from "./Logo";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#E2E8F0] bg-white mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="space-y-3">
          <Logo />
          <p className="text-sm text-[#475569] max-w-xs">Professional email at your domain — forwarded to your existing Gmail in under 3 minutes.</p>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-[#0F172A] mb-3">Product</h4>
          <ul className="space-y-2 text-sm text-[#475569]">
            <li><a href="/#how" className="hover:text-[#F26953]">How it works</a></li>
            <li><a href="/#pricing" className="hover:text-[#F26953]">Pricing</a></li>
            <li><Link to="/blog" data-testid="footer-blog-link" className="hover:text-[#F26953]">Blog</Link></li>
            <li><a href="/#faq" className="hover:text-[#F26953]">FAQ</a></li>
            <li><Link to="/workspace-upgrade" data-testid="footer-workspace-link" className="hover:text-[#F26953]">Google Workspace</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-[#0F172A] mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-[#475569]">
            <li><a className="hover:text-[#F26953]" href="https://olypayroll.com" target="_blank" rel="noreferrer">oly Payroll</a></li>
            <li><a href="mailto:support@olyinbox.com" className="hover:text-[#F26953]">Support</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-[#0F172A] mb-3">Legal</h4>
          <ul className="space-y-2 text-sm text-[#475569]">
            <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#F26953]">Terms of Service</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[#F26953]">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E2E8F0] py-6 text-center text-xs text-[#94A3B8]">
        © {new Date().getFullYear()} oly Inbox. Built by the team behind oly Payroll.
      </div>
    </footer>
  );
}
